const NOTE_BASE_ROUTE = '/note';

export const NOTE_API_ROUTES = {
  index: () => NOTE_BASE_ROUTE,
  createNote: (notebookId: string) => `${NOTE_BASE_ROUTE}/create/${notebookId}`,
  noteSnip: (noteId: string) => `${NOTE_BASE_ROUTE}/snip/${noteId}`,
  noteInfo: (noteId: string) => `${NOTE_BASE_ROUTE}/${noteId}`,
} as const;
